import { useState, useMemo } from "react";
import { FileBarChart2, Download } from "lucide-react";
import {
  bayiReport, bayiDailyBreakdown, TEAMS, formatTRY, formatInt, exportCSV, DATE_MIN, DATE_MAX,
} from "../data/mock";

export default function SahaRaporu() {
  const [selected, setSelected] = useState("SRL201");
  const rows = useMemo(() => bayiReport({}), []);
  const daily = useMemo(() => bayiDailyBreakdown(selected), [selected]);
  const sel = rows.find((r) => r.id === selected);

  const totals = rows.reduce(
    (a, r) => ({ yatirim: a.yatirim + r.yatirim, cekim: a.cekim + r.cekim, komisyon: a.komisyon + r.komisyon, islem: a.islem + r.islemAdedi }),
    { yatirim: 0, cekim: 0, komisyon: 0, islem: 0 }
  );

  return (
    <div className="space-y-5" data-testid="page-saha-raporu">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
            <FileBarChart2 className="text-[#F0651E]" size={22} />
          </div>
          <div>
            <h1 className="text-xl font-extrabold">Saha Raporu</h1>
            <p className="text-xs text-slate-500">Bayi bazlı miktar ve işlem adedi · {DATE_MIN.split("-").reverse().join(".")} – {DATE_MAX.split("-").reverse().join(".")}</p>
          </div>
        </div>
        <button
          onClick={() => exportCSV(rows.map((r) => ({ Bayi: r.name, MinYatirim: r.minLabel, Yatirim: r.yatirim, Cekim: r.cekim, Komisyon: r.komisyon, IslemAdedi: r.islemAdedi, GunlukOrtCiro: Math.round(r.gunlukOrtCiro) })), "saha-raporu.csv")}
          className="flex items-center gap-2 rounded-xl bg-[#F0651E] px-4 py-2.5 text-sm font-bold text-white hover:bg-[#d9560f] shadow-md shadow-orange-500/25 self-start"
          data-testid="btn-excel"
        >
          <Download size={16} /> EXCEL
        </button>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {[
          { l: "Toplam Yatırım", v: formatTRY(totals.yatirim), c: "text-green-600" },
          { l: "Toplam Çekim", v: formatTRY(totals.cekim), c: "text-red-500" },
          { l: "Toplam Komisyon", v: formatTRY(totals.komisyon), c: "text-amber-500" },
          { l: "Toplam İşlem", v: formatInt(totals.islem), c: "text-[#F0651E]" },
        ].map((k) => (
          <div key={k.l} className="bg-white dark:bg-[#151824] rounded-2xl p-4 shadow-sm border border-slate-100 dark:border-slate-800">
            <div className="text-xs font-semibold text-slate-500">{k.l}</div>
            <div className={`text-lg font-extrabold mt-1 ${k.c}`}>{k.v}</div>
          </div>
        ))}
      </div>

      {/* Bayi özet tablosu */}
      <div className="bg-white dark:bg-[#151824] rounded-2xl shadow-sm border border-slate-100 dark:border-slate-800 overflow-hidden">
        <div className="px-6 py-4 border-b border-slate-100 dark:border-slate-800 font-bold">Bayi Özeti</div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[13px] font-bold text-violet-600 dark:text-violet-400 border-b border-slate-100 dark:border-slate-800">
                <th className="px-6 py-3">BAYİ</th>
                <th className="px-4 py-3">MİN. YATIRIM</th>
                <th className="px-4 py-3 text-right">TOPLAM YATIRIM</th>
                <th className="px-4 py-3 text-right">TOPLAM ÇEKİM</th>
                <th className="px-4 py-3 text-right">KOMİSYON</th>
                <th className="px-4 py-3 text-right">GÜNLÜK ORT. CİRO</th>
                <th className="px-4 py-3 text-right">İŞLEM / 1M</th>
                <th className="px-6 py-3 text-right">İŞLEM ADEDİ</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
              {rows.map((r) => (
                <tr key={r.id} onClick={() => setSelected(r.id)} className={`cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/50 ${selected === r.id ? "bg-orange-50 dark:bg-orange-900/10" : ""}`} data-testid="rapor-row">
                  <td className="px-6 py-3 font-bold text-slate-700 dark:text-slate-200 flex items-center gap-2">
                    <span className="w-2.5 h-2.5 rounded-full" style={{ background: r.color }} />{r.name}
                  </td>
                  <td className="px-4 py-3"><span className="font-semibold" style={{ color: r.color }}>{r.minLabel}</span></td>
                  <td className="px-4 py-3 text-right font-bold text-green-600">{formatTRY(r.yatirim)}</td>
                  <td className="px-4 py-3 text-right font-semibold text-red-500">{formatTRY(r.cekim)}</td>
                  <td className="px-4 py-3 text-right text-amber-500 font-semibold">{formatTRY(r.komisyon)}</td>
                  <td className="px-4 py-3 text-right text-slate-600 dark:text-slate-300">{formatTRY(r.gunlukOrtCiro)}</td>
                  <td className="px-4 py-3 text-right text-slate-500">~{formatInt(r.islemBasi1M)}</td>
                  <td className="px-6 py-3 text-right font-bold">{formatInt(r.islemAdedi)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Seçili bayi günlük dökümü */}
      <div className="bg-white dark:bg-[#151824] rounded-2xl shadow-sm border border-slate-100 dark:border-slate-800 overflow-hidden">
        <div className="px-6 py-4 border-b border-slate-100 dark:border-slate-800 font-bold flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full" style={{ background: sel?.color }} />
          {sel?.name} Günlük Döküm <span className="text-xs font-normal text-slate-400">(Min. {sel?.minLabel})</span>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[13px] font-bold text-violet-600 dark:text-violet-400 border-b border-slate-100 dark:border-slate-800">
                <th className="px-6 py-3">TARİH</th>
                <th className="px-4 py-3 text-right">YATIRIM</th>
                <th className="px-4 py-3 text-right">ÇEKİM</th>
                <th className="px-4 py-3 text-right">KOMİSYON</th>
                <th className="px-6 py-3 text-right">İŞLEM ADEDİ</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
              {daily.map((d) => (
                <tr key={d.gun} className="hover:bg-slate-50 dark:hover:bg-slate-800/50">
                  <td className="px-6 py-3 font-semibold">{d.gun}</td>
                  <td className="px-4 py-3 text-right font-bold text-green-600">{formatTRY(d.yatirim)}</td>
                  <td className="px-4 py-3 text-right text-red-500 font-semibold">{formatTRY(d.cekim)}</td>
                  <td className="px-4 py-3 text-right text-amber-500">{formatTRY(d.komisyon)}</td>
                  <td className="px-6 py-3 text-right font-bold">{formatInt(d.islem)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
